import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import CreateExteriorInteriorColorsForm from '../../../modules/exteriorInteriorColors/components/CreateExteriorInteriorColorsForm';

const CreateExteriorInteriorColor = ({ interior }: { interior?: boolean }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const type = interior ? 'interior' : 'exterior';
  const title = id ? t(`edit_${type}_color`) : t(`create_${type}_color`);
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: `/${type}-colors/create-${type}-color` }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateExteriorInteriorColorsForm interior={interior}/>
    </div>
  );
};

export default CreateExteriorInteriorColor;
